import React, {useEffect, useState} from 'react'
import {WorkHubSubscriptionDetails} from "../../pages/apps/workhub/workHubSubscriptionDetails";
import SimpleReactValidator from "simple-react-validator";
import {useAppDispatch} from "../../store";
import {useSelector} from "react-redux";
import {saveWorkhubData} from "../../store/actions/workhub.action";
import {WidgetRate} from "../../pages/single-app/models/response/single-app.model";

type Props = {
    appDetails: any
}

const ChargeableTypeTwoComponent = ({appDetails}: Props) => {

    const [licenseType, setLicenseType] = useState<string>('');
    const [licenseCount, setLicenseCount] = useState<number>(0);
    const [usageCount, setUsageCount] = React.useState('');
    const [maxWidgetCount, setMaxWidgetCount] = React.useState(0);
    const [subscriptionRate, setSubscriptionRate] = React.useState(0.00);
    const [workhubData, setWorkhubData] = React.useState({
        "widgetCount": 0,
        "subscriptionRate": 0,
        "workhubConfigId": "",
        "masterWidgetUuid": "",
        "isChanged": false
    });
    const [validator] = useState(new SimpleReactValidator());

    const dispatch = useAppDispatch();

    const { userDetails } = useSelector<any, any>(({user}) => user);

    // Initialize usageCount from widgetRate if available
    useEffect(() => {
        if (appDetails && appDetails.widgetDetails && Array.isArray(appDetails.widgetDetails.WidgetRate)) {
            appDetails.widgetDetails.WidgetRate.forEach((widgetRate: WidgetRate) => {
                if (Array.isArray(widgetRate.RatePlaneDetails) && widgetRate.RatePlaneDetails.length > 0) {
                    setUsageCount(JSON.stringify(widgetRate));
                }
            });
        }
    }, [appDetails]);

    // Save workhubData whenever it changes
    useEffect(() => {
        dispatch(saveWorkhubData(workhubData));
    }, [workhubData]);

    const onChangePackage = async (e: any) => {
        if (appDetails?.widgetDetails?.isPaymentMethodEditable) {
            setUsageCount(e.target.value);
            let subRate = JSON.parse(e.target.value).rate * maxWidgetCount;
            setSubscriptionRate(subRate);
            setWorkhubData({
                ...workhubData,
                subscriptionRate: subRate
            });
        }
    }

    const onChangeWidgetCount = async (value: any) => {
        if (appDetails?.widgetDetails?.isPaymentMethodEditable) {
            setMaxWidgetCount(value);
            let subRate = value * JSON.parse(usageCount).rate;
            setSubscriptionRate(subRate);
            setWorkhubData({
                ...workhubData,
                widgetCount: value,
                subscriptionRate: subRate,
                isChanged: true
            });
        }
    }

    return (
        <div className="panel-table-content-list">
            <WorkHubSubscriptionDetails
                appDetails={appDetails}
                tenantUuid={userDetails?.OwnedEnterprises[0]?.groupId}
                widgetUuid={appDetails.widgetDetails.uuid}
                maxWidgetCount={maxWidgetCount}
            />
        </div>
    )
}

export {ChargeableTypeTwoComponent}
